webpackJsonp([140378131144412],{

/***/ 885:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/II. Violons du Roy (DancingMasterLS (violons).67c6b44b.jpg";

/***/ }),

/***/ 308:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(11);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _flexContainer = __webpack_require__(8);
	
	var _flexContainer2 = _interopRequireDefault(_flexContainer);
	
	var _sidebarLeft = __webpack_require__(12);
	
	var _sidebarLeft2 = _interopRequireDefault(_sidebarLeft);
	
	var _sidebarRight = __webpack_require__(13);
	
	var _sidebarRight2 = _interopRequireDefault(_sidebarRight);
	
	var _container = __webpack_require__(6);
	
	var _container2 = _interopRequireDefault(_container);
	
	var _titreAxe = __webpack_require__(14);
	
	var _titreAxe2 = _interopRequireDefault(_titreAxe);
	
	var _collectif = __webpack_require__(39);
	
	var _collectif2 = _interopRequireDefault(_collectif);
	
	var _btnLePalaisMontcalm = __webpack_require__(97);
	
	var _btnLePalaisMontcalm2 = _interopRequireDefault(_btnLePalaisMontcalm);
	
	var _btnSymeon = __webpack_require__(102);
	
	var _btnSymeon2 = _interopRequireDefault(_btnSymeon);
	
	var _btnHenrietteBelley = __webpack_require__(94);
	
	var _btnHenrietteBelley2 = _interopRequireDefault(_btnHenrietteBelley);
	
	var _btnCapsuleViolons = __webpack_require__(87);
	
	var _btnCapsuleViolons2 = _interopRequireDefault(_btnCapsuleViolons);
	
	var _info = __webpack_require__(7);
	
	var _info2 = _interopRequireDefault(_info);
	
	var _IIViolonsDuRoyDancingMasterLSViolons = __webpack_require__(885);
	
	var _IIViolonsDuRoyDancingMasterLSViolons2 = _interopRequireDefault(_IIViolonsDuRoyDancingMasterLSViolons);
	
	var _indexModule = __webpack_require__(16);
	
	var _indexModule2 = _interopRequireDefault(_indexModule);
	
	var _imageFooterAxe = __webpack_require__(109);
	
	var _imageFooterAxe2 = _interopRequireDefault(_imageFooterAxe);
	
	var _fragAxe = __webpack_require__(104);
	
	var _fragAxe2 = _interopRequireDefault(_fragAxe);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SecondPage = function SecondPage() {
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	            _flexContainer2.default,
	            null,
	            _react2.default.createElement(_reactHelmet2.default, { bodyAttributes: { class: 'fondations' } }),
	            _react2.default.createElement(
	                _sidebarLeft2.default,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { style: { width: "100%", height: "740px", display: "flex", flexDirection: "column", justifyContent: "space-between", alignItems: "flex-end", paddingBottom: "1.45rem" } },
	                    _react2.default.createElement(
	                        'div',
	                        { style: { maxWidth: "700px", width: "100%", height: "auto" } },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'metadata--wrapper' },
	                            _react2.default.createElement('img', { src: _IIViolonsDuRoyDancingMasterLSViolons2.default, alt: '' }),
	                            _react2.default.createElement(
	                                _info2.default,
	                                null,
	                                'L\'esprit des Violons du Roy en un autre temps. Illustration de Jean-Philippe Le Bas, Le ma\xEEtre de danse, 1745.'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                _container2.default,
	                null,
	                _react2.default.createElement(
	                    _titreAxe2.default,
	                    null,
	                    'Monuments'
	                ),
	                _react2.default.createElement(_collectif2.default, null),
	                _react2.default.createElement(
	                    'h1',
	                    null,
	                    'Violons du Roy'
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    'R\xE9unis pour la premie\u0300re fois en 1984, les Violons du Roy ont fait leur marque par la mai\u0302trise du re\u0301pertoire baroque. Multipliant les collaborations internationales, profitant d\'une re\u0301sidence permanente au Palais Montcalm, ils sont devenus une institution culturelle de la capitale. Porte\u0301 par un double inte\u0301re\u0302t pour la me\u0301moire et l\'utopie, la re\u0301alisation de Ludovica s\'est approche\u0301e de l\'ensemble avec une perspective dialectique: histoire et esthe\u0301tique.'
	                ),
	                _react2.default.createElement(
	                    'a',
	                    { href: 'http://violonsduroy.com/' },
	                    'violonsduroy.com'
	                ),
	                _react2.default.createElement(_fragAxe2.default, null)
	            ),
	            _react2.default.createElement(
	                _sidebarRight2.default,
	                null,
	                _react2.default.createElement(_btnCapsuleViolons2.default, null),
	                _react2.default.createElement(_btnLePalaisMontcalm2.default, null),
	                _react2.default.createElement(_btnSymeon2.default, null),
	                _react2.default.createElement(_btnHenrietteBelley2.default, null)
	            )
	        ),
	        _react2.default.createElement(_imageFooterAxe2.default, null)
	    );
	};
	
	exports.default = SecondPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-collectif-musical-violons-du-roy-js-232db3e567df2fde9510.js